import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { Producto } from 'src/app/models/generic/Producto';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { MenuService } from '../../services/menu.service';
import { ProductosService } from '../../services/productos.service';
import { ProductosResumen } from '../../models/generic/ProductosResumen';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { TopCiudadesResumen } from 'src/app/models/generic/TopCiudadesResumen';
import { NuevosInactivosAfiliadosResumen_DTO } from 'src/app/models/generic/TopNuevosInactivosAfiliadosResumen';
import { ApexAxisChartSeries, ApexChart, ChartComponent, ApexDataLabels, ApexXAxis, ApexPlotOptions, ApexTitleSubtitle } from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis[];
  colors: string[],
  stroke: ApexStroke,
  title: ApexTitleSubtitle,
  subtitle: ApexTitleSubtitle,
  tooltip: ApexTooltip,
  legend: ApexLegend
};

@Component({
  selector: 'globalnuevosinactivos',
  templateUrl: './globalnuevosinactivos.component.html',
  styleUrls: ['./globalnuevosinactivos.component.scss']
})
export class GlobalnuevosinactivosComponent implements OnInit{
  mostrarCargando: boolean = true;
  cantidadMaximaNuevos: number = 0;
  cantidadMaximaInactivos: number = 0;
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public autenticacionService: AutenticacionService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public tamanoAppService: TamanoAppService) {
      this.RecargarGrafica();
    }

  ngOnInit() {
    if (this.autenticacionService.EstaAutenticado()) {
      this.cargarResumen();

      this.productosService.NotificarCambiarResumen.subscribe((cambiarResumen: boolean) => {
        if (cambiarResumen) {
          this.cargarResumen();
        }
      });
    }
  }

  cargarResumen() {
    this.mostrarCargando = true;
    
    let parametrosConsulta = this.fb.group({
      mes: 0,
      idAplicacion: 0,
      canal: ''
    });

    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionadoInicial);
    parametrosConsulta.get('canal').setValue(this.autenticacionService.DescripcionCanalSeleccionadoInicial);
    this.productosService.CargarTopNuevosInactivosAfiliadosResumen(parametrosConsulta.value).subscribe((resp: NuevosInactivosAfiliadosResumen_DTO[]) => {
      this.productosService.ListaTopNuevosInactivosAfiliadosResumen = resp;
      for (let index = 0; index < this.productosService.ListaTopNuevosInactivosAfiliadosResumen.length; index++) {
        if (this.productosService.ListaTopNuevosInactivosAfiliadosResumen[index].cantidadNuevos >= this.cantidadMaximaNuevos) {
          this.cantidadMaximaNuevos = this.productosService.ListaTopNuevosInactivosAfiliadosResumen[index].cantidadNuevos;
        }
        if (this.productosService.ListaTopNuevosInactivosAfiliadosResumen[index].cantidadInactivos >= this.cantidadMaximaInactivos) {
          this.cantidadMaximaInactivos = this.productosService.ListaTopNuevosInactivosAfiliadosResumen[index].cantidadInactivos;
        }
      }
      this.RecargarGrafica();
      this.mostrarCargando = false;
    },
    (error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  ObtenerPorcentajeResumenActivos(item: NuevosInactivosAfiliadosResumen_DTO): string {
    let porcentaje: number = (((item.cantidadNuevos*100)/this.cantidadMaximaNuevos)/100);
    return `--size:${porcentaje}; --color: #bf0d3e;`;
  }
  ObtenerPorcentajeResumenInactivos(item: NuevosInactivosAfiliadosResumen_DTO): string {
    let porcentaje: number = (((item.cantidadInactivos*100)/this.cantidadMaximaInactivos)/100);
    return `--size:${porcentaje}; --color: #c7c7c7;`;
  }
  RecargarGrafica() {
    let listDataInactivos: number [] = [];
    let listDataNuevos: number [] = [];
    let listDataMayores: number [] = [];
    let listMeses: string [] = [];

    if (this.utilitariosService.VerificarContieneDatos(this.productosService.ListaTopNuevosInactivosAfiliadosResumen)) {
      for (let index = 0; index < this.productosService.ListaTopNuevosInactivosAfiliadosResumen.length; index++) {
        if (this.productosService.ListaTopNuevosInactivosAfiliadosResumen[index].cantidadInactivos > this.productosService.ListaTopNuevosInactivosAfiliadosResumen[index].cantidadNuevos) {
          listDataMayores.push(this.productosService.ListaTopNuevosInactivosAfiliadosResumen[index].cantidadInactivos);     
        } else {
          listDataMayores.push(this.productosService.ListaTopNuevosInactivosAfiliadosResumen[index].cantidadNuevos);
        }
  
        listDataInactivos.push(this.productosService.ListaTopNuevosInactivosAfiliadosResumen[index].cantidadInactivos);
        listDataNuevos.push(this.productosService.ListaTopNuevosInactivosAfiliadosResumen[index].cantidadNuevos);
        
        listMeses.push(this.productosService.ListaTopNuevosInactivosAfiliadosResumen[index].mes);
      }
    }

    this.chartOptions = {
      series: [{
      name: 'Cantidad mayor',
      type: 'line',
      data: listDataMayores
    }, {
      name: 'Inactivos',
      type: 'column',
      data: listDataInactivos
    }, {
      name: 'Nuevos',
      type: 'column',
      data: listDataNuevos
    }],
      chart: {
      height: 350,
      type: 'line',
      stacked: false,
      redrawOnParentResize: true,
      toolbar: {
        show: false
      },
    },
    colors: ['#FEB019', '#707070', '#bf0d3e'],
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: [4, 1, 1]
    },
    title: {
      text: '',
      align: 'left',
      offsetX: 110
    },
    xaxis: {
      categories: listMeses,
    },
    yaxis: [
      {
        seriesName: 'Cantidad mayor',
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: false
        },
        labels: {
          show: false
        },
        title: {
          text: ""
        },
        tooltip: {
          enabled: true
        }
      },
      {
        seriesName: 'Nuevos',
        opposite: false,
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true
        },
        labels: {
          show: false
        },
        title: {
          text: ""
        },
      },
      {
        seriesName: 'Inactivos',
        opposite: true,
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true
        },
        labels: {
          show: true
        },
        title: {
          text: ""
        }
      },
    ],
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60
      },
    },
    legend: {
      horizontalAlign: 'left',
      offsetX: 40
    }
    };
  }
}
